import styled from 'styled-components';

// ShowMore Container
export const StyledShowMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--spacing-4);
  padding: var(--spacing-6);
  background-color: var(--color-white);
  width: 100%;
`;

// ShowMore Info
export const StyledShowMoreInfo = styled.div`
  color: var(--color-gray-600);
  font-size: var(--font-size-14);
  text-align: center;
`;

// ShowMore Button
export const StyledShowMoreButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3) var(--spacing-6);
  border: 1px solid var(--color-primary-600);
  border-radius: var(--radius-lg);
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: var(--transition-fast);
  min-width: 120px;

  ${({ $variant }) => $variant === 'secondary' ? `
    background-color: var(--color-white);
    color: var(--color-primary-600);
    border-color: var(--color-gray-300);

    &:hover:not(:disabled) {
      background-color: var(--color-gray-50);
      border-color: var(--color-gray-400);
    }
  ` : `
    background-color: var(--color-primary-600);
    color: var(--color-white);

    &:hover:not(:disabled) {
      background-color: var(--color-primary-700);
    }
  `}

  &:focus {
    outline: 2px solid var(--color-primary-500);
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: var(--color-gray-100);
    color: var(--color-gray-400);
    border-color: var(--color-gray-300);
  }
`;

// ShowMore Actions Container
export const StyledShowMoreActions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
`;

// Show All Link
export const StyledShowAllLink = styled.button`
  background: none;
  border: none;
  color: var(--color-primary-600);
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: var(--transition-fast);
  padding: var(--spacing-2);
  border-radius: var(--radius-md);

  &:hover {
    color: var(--color-primary-700);
    background-color: var(--color-primary-25);
  }

  &:focus {
    outline: 2px solid var(--color-primary-500);
    outline-offset: 2px;
  }
`;

// Progress Bar (optional visual indicator)
export const StyledProgressBar = styled.div`
  width: 100%;
  max-width: 400px;
  height: 4px;
  background-color: var(--color-gray-200);
  border-radius: var(--radius-full);
  overflow: hidden;
`;

export const StyledProgressFill = styled.div<{ $progress: number }>`
  height: 100%;
  background-color: var(--color-primary-600);
  border-radius: var(--radius-full);
  transition: width var(--transition-normal);
  width: ${({ $progress }) => Math.min(100, Math.max(0, $progress))}%;
`; 